<template lang="pug">
v-card.custom-card(outlined)
  template(v-if="ativo")
    .permissao-header.d-flex.align-center.justify-space-between.gap-2
      .permissao-titulo {{ titulo }}
      v-btn.btn-action.text-none(
        small,
        outlined,
        :disabled="!temAtivas",
        @click="$emit('toggle-todas')"
      ) {{ todasPermitidas ? textoDesmarcarTodos : textoMarcarTodos }}
    .permissao-subtitle.pb-2.pt-2 {{ prefixoItem }}: {{ nomeItem }}
    v-divider
    .permissao-lista(v-if="empresas.length > 0")
      .permissao-empresa-item.d-flex.align-center.justify-space-between.px-3.py-2(
        v-for="empresa in empresas",
        :key="empresa.codigoempresa"
      )
        .d-flex.align-center
          .permissao-numero(
            :class="{ 'permissao-numero--inativa': empresa.empresaativa === false }"
          ) {{ empresa.codigoempresa }}
          span.permissao-empresa-nome {{ empresa.fantasia || empresa.razaosocial }}
        v-spacer
        //- Badge opcional explicando por que o item está travado
        v-chip.permissao-badge.mr-2(
          v-if="badgeItem(empresa)",
          x-small,
          outlined,
          :color="badgeItem(empresa).cor"
        ) {{ badgeItem(empresa).texto }}
        v-chip.permissao-chip(
          v-if="empresa.empresaativa !== false && !badgeItem(empresa)",
          x-small,
          :color="chipColor(empresa).color",
          :text-color="chipColor(empresa).textColor",
          @click="$emit('toggle', empresa)"
        ) {{ temPermissao(empresa) ? "Sim" : "Não" }}
        v-chip.permissao-chip.permissao-chip--disabled(
          v-else,
          x-small,
          disabled,
          color="grey lighten-2",
          text-color="grey darken-1"
        ) {{ temPermissao(empresa) ? "Sim" : "Não" }}
    div(v-else)
      .permissao-empty.text-center.py-8
        v-icon.empty-state-icon(size="48", color="blue lighten-3") mdi-domain-off
        .empty-state-subtitle.mt-4 {{ textoSemEmpresas }}

  //- Estado vazio: modo por empresa
  .permissao-empty.text-center.py-8(v-else-if="modoEmpresa")
    v-icon.empty-state-icon(size="48", color="red lighten-3") mdi-format-color-marker-cancel
    .empty-state-subtitle.mt-4 {{ textoModoEmpresa }}

  //- Estado vazio: nada selecionado
  .permissao-empty.text-center.py-8(v-else)
    v-icon.empty-state-icon(size="48", color="blue lighten-3") mdi-menu-open
    .empty-state-subtitle.mt-4 {{ textoSemSelecao }}
</template>

<script>
export default {
  name: "PermissaoEmpresaCard",

  props: {
    titulo: {
      type: String,
      default: "Permissão por empresa"
    },
    ativo: {
      type: Boolean,
      default: false
    },
    modoEmpresa: {
      type: Boolean,
      default: false
    },
    empresas: {
      type: Array,
      default: () => []
    },
    nomeItem: {
      type: String,
      default: ""
    },
    prefixoItem: {
      type: String,
      default: "Menu"
    },
    todasPermitidas: {
      type: Boolean,
      default: false
    },
    temAtivas: {
      type: Boolean,
      default: false
    },
    temPermissao: {
      type: Function,
      default: () => false
    },
    chipColor: {
      type: Function,
      default: () => ({ color: "grey lighten-2", textColor: "grey darken-1" })
    },
    // Retorna { texto, cor } para sinalizar um item não editável, ou null
    // quando o item segue normalmente editável.
    badgeItem: {
      type: Function,
      default: () => null
    },
    textoMarcarTodos: {
      type: String,
      default: "Marcar Todos"
    },
    textoDesmarcarTodos: {
      type: String,
      default: "Desmarcar Todos"
    },
    textoSemEmpresas: {
      type: String,
      default: "Nenhuma empresa selecionada para este menu"
    },
    textoModoEmpresa: {
      type: String,
      default:
        'No tipo de manipulação "Por empresa", utilize as checkbox disponíveis na árvore de menus'
    },
    textoSemSelecao: {
      type: String,
      default: "Selecione um cliente e menu para configurar as permissões por empresa"
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.btn-action {
  height: 30px !important;
  min-width: 0 !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  border: 1px solid #d0d7de !important;
  color: #57606a !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.text-none {
  text-transform: none !important;
}

.permissao-header {
  flex: 0 0 auto;
  min-height: 56px;
  padding: 0 18px;
  display: flex;
  align-items: center;
}

.gap-2 {
  gap: 8px;
}

.permissao-titulo {
  color: #0f2b57;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.permissao-subtitle {
  flex: 0 0 auto;
  padding: 0 18px;
  font-size: 12px;
  color: #1976d2;
  font-weight: 600;
}

.permissao-lista {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
}

.permissao-empresa-item {
  border-bottom: 1px solid #e8eef4;
  transition: background-color 0.15s;
}

.permissao-empresa-item:hover {
  background-color: #f5f9ff;
}

.permissao-empresa-item:last-child {
  border-bottom: none;
}

.permissao-numero {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #1976d2;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  flex-shrink: 0;
}

.permissao-numero--inativa {
  background-color: #9e9e9e !important;
}

.permissao-empresa-nome {
  font-size: 12px;
  color: #444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.permissao-chip {
  cursor: pointer;
  font-weight: 700 !important;
  font-size: 10px !important;
}

.permissao-chip--disabled {
  opacity: 0.6;
  cursor: default !important;
  pointer-events: none;
}

.permissao-badge {
  font-weight: 600;
  font-size: 10px !important;
  height: 18px !important;
}

.permissao-empty {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}
</style>
